import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UserSchedule } from '@training/models/user-schedule.model';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import {
  RememberUserSchedule,
  ResetUserSchedule
} from './user-schedule.actions';

export class UserScheduleStateModel {
  readonly userSchedule: UserSchedule;
  readonly isLoaded: boolean;
}

@State<UserScheduleStateModel>({
  name: AppStoreKeys.UserSchedule,
  defaults: {
    userSchedule: {
      isSimSessionWaitingForTsa: false,
      scheduleAvailable: true,
      lastUpdated: '',
      dailySessions: [],
      cutOffDate: new Date(),
      scheduleNotifications: []
    },
    isLoaded: false
  }
})
@Injectable()
export class UserScheduleState {
  @Selector()
  public static getState(
    state: UserScheduleStateModel
  ): UserScheduleStateModel {
    return state;
  }

  @Action(RememberUserSchedule)
  rememberSchedule(
    context: StateContext<UserScheduleStateModel>,
    action: RememberUserSchedule
  ): void {
    context.patchState({
      userSchedule: action.payload,
      isLoaded: action.isLoaded
    });
  }

  @Action(ResetUserSchedule)
  resetSchedule(context: StateContext<UserScheduleStateModel>): void {
    context.setState({
      userSchedule: {
        isSimSessionWaitingForTsa: false,
        scheduleAvailable: true,
        lastUpdated: '',
        dailySessions: [],
        cutOffDate: new Date(),
        scheduleNotifications: []
      },
      isLoaded: false
    });
  }
}
